import type { TBoard } from '../types';
import { BOARD_SIZE, EMPTY_CELL } from '../constants';

export function createEmptyBoard(): TBoard {
  return Array.from({ length: BOARD_SIZE }, () =>
    Array.from({ length: BOARD_SIZE }, () => EMPTY_CELL),
  );
}
